<div class="h-full w-full" *transloco="let t; prefix: 'fidelity-app'">
    <div [formGroup]="registrationForm" class="grid w-full grid-cols-1 gap-y-2" *transloco="let gt">
        @if (shouldShowCardInput()) {
            <p class="text-lg text-tb-primary">{{ t('register.existing-card-title') }}</p>
            <p class="text-secondary">
                {{ t('register.existing-card-description') }}<sup class="after:content-['1']"></sup>
            </p>

            <!-- Existing card number -->
            <mat-form-field>
                <mat-label>
                    {{ t('register.card-number') }}
                </mat-label>
                <input matInput formControlName="cardNumber" />
                <mat-icon svgIcon="heroicons_outline:credit-card" matSuffix></mat-icon>
            </mat-form-field>

            <p class="text-secondary text-sm">
                <sup class="after:content-['1']"></sup>: {{ t('register.existing-card-note') }}
            </p>

            <mat-divider></mat-divider>
        }

        <p class="text-lg text-tb-primary">{{ t('register.login-data-title') }}</p>

        <!-- Email -->
        <mat-form-field>
            <mat-label>
                {{ gt('generic.email') }}
            </mat-label>
            <input matInput formControlName="email" #email />
            <mat-hint align="start">{{ gt('hints.max-length', { max: ADDRESS_MAX_LENGTHS.EMAIL }) }}</mat-hint>
            <mat-hint align="end">{{ email.value.length }}/{{ ADDRESS_MAX_LENGTHS.EMAIL }}</mat-hint>
            @if (registrationForm.get('email').hasError('required')) {
                <mat-error>{{ gt('validation.req') }}</mat-error>
            }
            @if (registrationForm.get('email').hasError('maxlength')) {
                <mat-error>{{ gt('validation.max-length') }}</mat-error>
            }
            @if (registrationForm.get('email').hasError('email')) {
                <mat-error>{{ gt('validation.email') }}</mat-error>
            }
        </mat-form-field>

        <!-- Password -->
        <mat-form-field>
            <mat-label>
                {{ gt('generic.password') }}
            </mat-label>
            <input matInput type="password" formControlName="password" autocomplete="current-password" #passwordField />
            <button
                mat-icon-button
                type="button"
                (click)="
                    passwordField.type === 'password'
                        ? (passwordField.type = 'text')
                        : (passwordField.type = 'password')
                "
                matSuffix
            >
                @if (passwordField.type === 'password') {
                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:eye'"></mat-icon>
                }
                @if (passwordField.type === 'text') {
                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:eye-slash'"></mat-icon>
                }
            </button>
            @if (registrationForm.get('password').hasError('required')) {
                <mat-error>{{ gt('validation.req') }}</mat-error>
            }
            @if (registrationForm.get('password').hasError('weakPassword')) {
                <mat-error>{{ gt('validation.pass-weak') }}</mat-error>
            }
        </mat-form-field>

        <div class="text-secondary list-disc text-sm" [innerHTML]="t('register.pw-rules') | safe"></div>

        <mat-divider></mat-divider>

        <p class="text-lg text-tb-primary">{{ t('register.personal-data-title') }}</p>

        <!-- First name -->
        <mat-form-field>
            <mat-label>
                {{ gt('generic.first-name') }}
            </mat-label>
            <input matInput formControlName="firstName" #firstName />
            <mat-hint align="start">{{ gt('hints.max-length', { max: CUSTOMER_MAX_LENGTHS.FIRST_NAME }) }}</mat-hint>
            <mat-hint align="end">{{ firstName.value.length }}/{{ CUSTOMER_MAX_LENGTHS.FIRST_NAME }}</mat-hint>
            @if (registrationForm.get('firstName').hasError('maxlength')) {
                <mat-error>{{ gt('validation.max-length') }}</mat-error>
            }
            @if (registrationForm.get('firstName').hasError('required')) {
                <mat-error>{{ gt('validation.req') }}</mat-error>
            }
        </mat-form-field>

        <!-- Last name -->
        <mat-form-field>
            <mat-label>
                {{ gt('generic.last-name') }}
            </mat-label>
            <input matInput formControlName="lastName" #lastName />
            <mat-hint align="start">{{ gt('hints.max-length', { max: CUSTOMER_MAX_LENGTHS.LAST_NAME }) }}</mat-hint>
            <mat-hint align="end">{{ lastName.value.length }}/{{ CUSTOMER_MAX_LENGTHS.LAST_NAME }}</mat-hint>
            @if (registrationForm.get('lastName').hasError('maxlength')) {
                <mat-error>{{ gt('validation.max-length') }}</mat-error>
            }
            @if (registrationForm.get('lastName').hasError('required')) {
                <mat-error>{{ gt('validation.req') }}</mat-error>
            }
        </mat-form-field>

        <!-- Birth date -->
        <mat-form-field>
            <mat-label>
                {{ gt('generic.dob') }}
            </mat-label>
            <input matInput [matDatepicker]="picker" formControlName="birthDate" [min]="minDate" [max]="maxDate" />
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <!-- Gender -->
        <mat-form-field>
            <mat-label>
                {{ gt('generic.gender') }}
            </mat-label>
            <mat-select formControlName="gender">
                <mat-option [value]="Gender.unspecified"
                    ><i class="text-secondary">{{ gt('genders.null') }}</i>
                </mat-option>
                <mat-option [value]="Gender.male">{{ gt('genders.male') }}</mat-option>
                <mat-option [value]="Gender.female">{{ gt('genders.female') }}</mat-option>
            </mat-select>
        </mat-form-field>

        <!-- City -->
        <mat-form-field>
            <mat-label>
                {{ gt('generic.city') }}
            </mat-label>
            <input matInput formControlName="city" #city />
            <mat-hint align="start">{{ gt('hints.max-length', { max: ADDRESS_MAX_LENGTHS.CITY }) }}</mat-hint>
            <mat-hint align="end">{{ city.value.length }}/ {{ ADDRESS_MAX_LENGTHS.CITY }}</mat-hint>
            @if (registrationForm.get('city').hasError('required')) {
                <mat-error>{{ gt('validation.req') }}</mat-error>
            }
            @if (registrationForm.get('city').hasError('maxlength')) {
                <mat-error>{{ gt('validation.max-length') }}</mat-error>
            }
        </mat-form-field>

        <!-- Zip code -->
        <mat-form-field>
            <mat-label>
                {{ gt('generic.zip') }}
            </mat-label>
            <input matInput formControlName="zipCode" inputmode="numeric" #zipCode />
            <mat-hint align="start">{{ gt('hints.max-length', { max: ADDRESS_MAX_LENGTHS.POSTAL_CODE }) }}</mat-hint>
            <mat-hint align="end">{{ zipCode.value.length }}/ {{ ADDRESS_MAX_LENGTHS.POSTAL_CODE }}</mat-hint>
            @if (registrationForm.get('zipCode').hasError('required')) {
                <mat-error>{{ gt('validation.req') }}</mat-error>
            }
            @if (registrationForm.get('zipCode').hasError('maxlength')) {
                <mat-error>{{ gt('validation.max-length') }}</mat-error>
            }
        </mat-form-field>

        <!-- Country -->
        <mat-form-field class="example-full-width">
            <mat-label>{{ gt('components.address-control.country') }}</mat-label>
            <input
                type="text"
                [placeholder]="gt('components.address-control.country')"
                matInput
                (input)="filterCountries($event)"
                [matAutocomplete]="auto"
                formControlName="country"
            />
            <mat-autocomplete
                autoActiveFirstOption=""
                requireSelection=""
                #auto="matAutocomplete"
                [displayWith]="getOptionName"
            >
                @for (option of filteredCountries(); track option.name) {
                    <mat-option [value]="option">{{ option.name }}</mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>

        <!-- Phone number -->
        <mat-form-field>
            <mat-label>
                {{ gt('generic.phone-number') }}
            </mat-label>
            <input matInput formControlName="phoneNumber" inputmode="numeric" #phoneNumber />
            <mat-icon svgIcon="mat_outline:phone" matSuffix></mat-icon>
            <mat-hint align="start"
                >{{ gt('hints.max-length', { max: ADDRESS_MAX_LENGTHS.PHONE_NUMBER_A }) }}
            </mat-hint>
            <mat-hint align="end">{{ phoneNumber.value.length }}/ {{ ADDRESS_MAX_LENGTHS.PHONE_NUMBER_A }}</mat-hint>
            @if (registrationForm.get('phoneNumber').hasError('pattern')) {
                <mat-error>{{ gt('validation.pattern-mismatch') }}</mat-error>
            }
            @if (registrationForm.get('phoneNumber').hasError('maxlength')) {
                <mat-error>{{ gt('validation.max-length') }}</mat-error>
            }
        </mat-form-field>

        <mat-divider></mat-divider>

        <p class="text-lg text-tb-primary">{{ t('register.documents-consents-title') }}</p>

        <p>{{ t('register.user-agreement') }}</p>

        <ul class="ml-4 list-disc py-2">
            @for (doc of legalDocuments; track doc.url) {
                <li>
                    @if (openPdfInModal()) {
                        <a class="cursor-pointer" (click)="openModal(doc.url)">{{ doc.text }}</a>
                    } @else {
                        <a target="_blank" [href]="doc.url">{{ doc.text }}</a>
                    }
                </li>
            }
        </ul>

        <mat-list class="w-full">
            <mat-list-item class="flex justify-between ps-0">
                <span matListItemTitle class="text-lg after:content-['*']">{{ t('register.terms') }}</span>
                <mat-slide-toggle
                    matListItemMeta
                    class="my-auto"
                    formControlName="consentTerms"
                    labelPosition="before"
                ></mat-slide-toggle>
            </mat-list-item>
            <mat-list-item class="flex justify-between ps-0">
                <span matListItemTitle class="text-lg">{{ t('register.marketing') }}</span>
                <mat-slide-toggle
                    matListItemMeta
                    class="my-auto"
                    formControlName="consentMarketing"
                    labelPosition="before"
                ></mat-slide-toggle>
            </mat-list-item>
            <mat-list-item class="flex justify-between ps-0">
                <span matListItemTitle class="text-lg">{{ t('register.profiling') }}</span>
                <mat-slide-toggle
                    matListItemMeta
                    class="my-auto"
                    formControlName="consentProfiling"
                    labelPosition="before"
                ></mat-slide-toggle>
            </mat-list-item>
        </mat-list>

        <!-- Alert -->
        @if (fullErrorMessage()) {
            <tb-dismissable-error
                [fullErrorMessage]="this.fullErrorMessage()"
                (onDismiss)="dismissError()"
            ></tb-dismissable-error>
        }

        <button
            class="fuse-mat-button-large mt-6 w-full enabled:bg-tb-primary enabled:text-tb-primary-contrast"
            mat-flat-button
            [disabled]="disableSubmit() || disableCrudActions()"
            (click)="register()"
        >
            @if (disableCrudActions()) {
                <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
            } @else {
                <span>
                    {{ t('register.register') }}
                </span>
            }
        </button>
    </div>
</div>
